module.exports = __webpack_public_path__ + "static/media/ic-logo-super-cle-a-num@2x.240c9777.png";